"use client";
import SectionHeader from "@/components/common/section-header";
import React, { useEffect, useState } from "react";
import { isa_introEN } from "@/assets/dictionaries/en/isa-content";
import { isa_introES } from "@/assets/dictionaries/es/isa-content";

const IsaIntro = () => {
  const [isaIntroContent, setIsaIntroContent] = useState(isa_introEN); // Default to English

  useEffect(() => {
    // Get the language from localStorage
    const lang = localStorage.getItem("selectedOption") || "EN"; // Default to EN if not found

    // Set the content based on the language
    switch (lang.toUpperCase()) {
      case "ES":
        setIsaIntroContent(isa_introES);
        break;
      case "EN":
      default:
        setIsaIntroContent(isa_introEN);
        break;
    }
  }, []); // Only run on mount
  return (
    <div className="pt-16">
      <h2 className="min-w-min sm:min-w-fit flex2D1 sm:flex-initial break-words text-4xl font-bold text-gbci-accent text-center">
        {isaIntroContent.intro_title}
      </h2>
      <div className="text-white text-xl text-center mt-20">
        {isaIntroContent.intro_desc}
      </div>
    </div>
  );
};

export default IsaIntro;
